import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

  formatNumber(num) {

    const numFloat = parseFloat(num);
    if(Number.isNaN(numFloat)) {
      return num;
    }
    return numFloat.toLocaleString(
      'en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 6
      }
    );
  }

  transform(value: number, ...args: unknown[]): unknown {
    return this.formatNumber(value);
  }

}
